import React from 'react'
import { IonIcon } from '@ionic/react'

export const EraserIcon = (props: { slot?: string }) => {
  return <IonIcon src={'/assets/icons/eraser.svg'} {...props} />
}
export default EraserIcon
